export const OptionTooltips = {
  fullSyncSchedule: (
    <div className="space-y-2">
      <p>
        Periodically run a full sync instead of an incremental one, re-syncing
        all data from the source. Useful for capturing deletes.
      </p>
      <p>
        Full syncs don&apos;t run on their own: when the schedule comes due, the
        next regular sync runs as a full sync. So they can&apos;t run more often
        than the table syncs.
      </p>
    </div>
  ),
  fullSyncScheduleShort: (
    <p>Periodically runs a full sync instead of an incremental one.</p>
  ),
  full: (
    <p>
      All data will be re-synced and overwritten every time. <br />
      <br />
      The operation is quite expensive, so use with care.
    </p>
  ),
  fullShort: <p>All data will be re-synced and overwritten every time.</p>,
  protected: (
    <p>
      If enabled, whenever there is a schema change requiring all data to be
      resynchronized, the sync will pause, and you will receive a notification.
      <br />
      If disabled, schema changes will trigger an automatic resynchronization of
      all data.
      <br />
      <br />
      This option is beneficial for safeguarding historical data not retained in
      the data source.
    </p>
  ),
  protectedShort: (
    <p>
      When schema changes require full data resynchronization, syncing pauses,
      and you receive a notification.
    </p>
  ),
  fullWarning: (
    <p>
      All rows will be re-synced and overwritten every time. This operation can
      be expensive for large tables.
      <br />
      <br />
      Click to configure incremental sync for this table.
    </p>
  ),
  incremental: (
    <p>
      Only new rows will be synced in incremental syncs. <br />
      <br />
      This can improve sync times significantly and reduce number of rows per
      sync.
    </p>
  ),
  incrementalShort: <p>Only new rows will be synced in incremental syncs.</p>,
  append: (
    <p>
      Only new rows will be appended. Old rows won't be updated. <br />
      <br />
      This can improve subsequent sync times significantly.
    </p>
  ),
  appendShort: (
    <p>Only new rows will be appended. Old rows won't be updated.</p>
  ),
  changeDataCapture: (
    <div>
      Change Data Capture (CDC) tracks and records changes (inserts, updates,
      deletes) in your database. Weld uses two extra columns to capture updates
      and deletions:
      <ul className="ml-2 list-inside list-disc">
        <li>
          <code>_weld_updated_at</code>
        </li>
        <li>
          <code>_weld_deleted_at</code>
        </li>
      </ul>
    </div>
  ),
  softDelete: (
    <div>
      Rows that disappear from the data source are kept instead of being removed
      from the table. They are marked with the time they disappeared:
      <ul className="ml-2 list-inside list-disc">
        <li>
          <code>_weld_deleted_at</code>
        </li>
      </ul>
      A row that reappears in the data source is unmarked again.
    </div>
  ),
  softDeleteShort: (
    <p>
      Rows that disappear from the data source are kept, marked with{" "}
      <code>_weld_deleted_at</code>.
    </p>
  ),
  historyTable: (plural: boolean) => (
    <p>
      {plural
        ? "Enable history tables to keep a snapshot of the data over time. New history tables will be maintained alongside the original table and sub-tables."
        : "Enable history table to keep a snapshot of the data over time. A new history table will be maintained alongside the original table."}
    </p>
  ),
};
